import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'
import { switchProp, withProp, ifProp } from 'styled-tools'

import hexToRgba from 'hex-to-rgba'
import { calcRem, rem } from '../../utils/styles'
import Menu from '../Menu'

const offsetCalc = withProp('offset', offset => `calc(100% + ${calcRem(offset, 16)})`)
const getVertical = ifProp('offset', offsetCalc, '100%')
const getAlign = switchProp('align', {
  left: css`left: 0;`,
  right: css`right: 0;`
})

const DropdownMenu = styled(Menu)`
  position: absolute;
  top: ${getVertical};
  min-width: 110%;
  ${getAlign}
  z-index: 100;
  box-shadow: ${rem(0)} ${rem(3)} ${rem(3)} ${hexToRgba('#000', 0.25)};
`
DropdownMenu.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  offset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

DropdownMenu.defaultProps = {
  align: 'left'
}

export default DropdownMenu
